import request from '@/utils/request'

/**
 * POST 方法 与 GET方法  区别
 *
 * post==> data: obj
 * get==>params: obj
 *this.$http.post('/apis/cityjson?ie=utf-8',{}).then(res => {
    console.log(res);
    //解析格式即可
 })
 */

// 例如(post)：
 export function updateBook(obj) {
   return request({
     url: 'http://pv.sohu.com/apis/cityjson?ie=utf-8',
     method: 'post',
     data: obj,
   })
 }
// 例如(get)：
 export function getBookList(obj) {
   return request({
     url: '/system/dict/data/list',
     method: 'get',
     params: obj,  
   })
}